import Vue from 'vue'
import Router from 'vue-router'
import loginRouter from './login'
import doctorRouter from './doctor'
import news from '@/components/base/news/news'
import noComponent from '@/components/base/error/noComponent'
import TestVux from '@/components/TestVux'

Vue.use(Router)

export default new Router({
  // 跳转url没有#号
  mode: 'history',
  routes: [
    ...loginRouter, //  扩展运算符,将一个数组转换为逗号分隔的参数
    ...doctorRouter,
    {
      path: '/newsdetail/:newsId',
      name: 'newsdetail',
      meta: {
        title: '新闻详情',
        keepAlive: false // 不需要被缓存
      },
      component: news
    }, {
      path: '/error',
      name: 'Error',
      meta: {
        title: '页面出错啦',
        keepAlive: false // 不需要被缓存
      },
      component: noComponent
    }, {
      path: '/TestVux',
      name: 'testVux',
      component: TestVux
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js